import { Box, Typography } from '@mui/material';

const EditProfileButton = ({ setEditMode, theme }) => (
  <Box
    sx={{
      display: 'flex',
      color: theme.custom.profile.editProfile.editProfileButton.color,
      alignItems: 'center',
      cursor: 'pointer',
      mb: 2,
      p: 1,
      gap: '8px',
    }}
    onClick={() => setEditMode(true)}
  >
    <img src={theme.custom.profile.editProfile.editProfileButton.imgSrc} alt="edit profile" />
    <Typography>Edit</Typography>
  </Box>
);

export default EditProfileButton;
